import { MoreHorizontal, Search } from "lucide-react";
import { Table, type MenuItem } from "@marekl/adminer/components";

export interface RowActionsProps {
  /** Items of the "akce" menu; none = no menu. */
  items?: MenuItem[];
  /** Where "detail" leads; none = no link. */
  to?: string;
  /** Names the row for screen readers ("dokladu FV26-001"). */
  label: string;
}

/**
 * The legacy list's action cell (legacy/app/src/utils/ListButtons.tsx):
 * "akce" (a menu) and "detail" (a link in the brand red), each an icon over
 * a small lowercase word — the library's stacked row actions.
 */
export function RowActions({ items = [], to, label }: RowActionsProps) {
  return (
    <Table.Actions>
      {items.length > 0 && (
        <Table.ActionMenu layout="stacked" startIcon={<MoreHorizontal />} aria-label={`Akce ${label}`} items={items}>
          akce
        </Table.ActionMenu>
      )}
      {to && (
        <Table.Action layout="stacked" variant="primary" to={to} startIcon={<Search />} aria-label={`Detail ${label}`}>
          detail
        </Table.Action>
      )}
    </Table.Actions>
  );
}
